import { getInitialAppState } from '@/app/helpers/get-initial-app-state';

import { useUserStateRaw } from '@/entities/user/model/user.store';

import { createServiceLoggerService } from '@/shared/services/service-logger/lib/create-service-logger-service';
import { logErrorMini } from '@/shared/services/service-logger/lib/log-error-mini';
import { initTgAnalyticsForTapps } from '@/shared/services/tg-analytics';
import { useAppStateRaw } from '@/shared/store/app-store/app-store';
import { type ThemeMode, type UIKit } from '@/shared/store/app-store/types';
import { useServiceStateRaw } from '@/shared/store/services-store/services-store';

import { INIT_URL_SESSION_KEY } from '../../../shared/constants';
import { useTgStateRaw } from '../../../shared/store/tg-store/tg-store';
import { type InitialState } from './types';

const setThemeForDOM = (theme: ThemeMode) => {
  document.documentElement.setAttribute('data-theme', theme);
};

const setUIKit = (uiKit: UIKit) => {
  document.documentElement.setAttribute('ui-kit', uiKit);
};

export const initApplication = async () => {
  let initialState = {} as InitialState;

  try {
    sessionStorage.setItem(INIT_URL_SESSION_KEY, window.location.href);

    initialState = await getInitialAppState();

    const { app, tg } = initialState;

    useAppStateRaw.getState().actions.hydrate(app);
    useTgStateRaw.getState().actions.hydrate(tg);

    const loggerService = createServiceLoggerService(initialState);
    useServiceStateRaw.getState().actions.hydrate({ loggerService });

    setThemeForDOM(initialState.app.theme);
    setUIKit(initialState.app.uiKit);

    if (initialState.app.token) await useUserStateRaw.getState().actions.fetchUser();

    await initTgAnalyticsForTapps(tg.startAppArgs.src);
  } catch (err) {
    void logErrorMini(err as Error, 'initApplication function');
    console.error(err);
    throw err;
  }

  return initialState;
};
